export interface Signature {
  templateId?: string;
  isPlaceholder?: boolean;
  order: number;
  name: string;
  content?: string;
  numberOfInstallations: number;
  numberOfAliases: number;
  numberOfInternalInstallations?: number;
  numberOfInternalAliases?: number;
  addonBannerId: string | null;
  addonAdditionalBannerId: string | null;
  addonLinkId: string | null;
  addonDisclaimerId: string | null;
  defaultForNewEmployee: boolean | undefined;
  userAvatarWidth?: number | undefined;
  userAvatarHeight?: number | undefined;
  userAvatarBorderRadius?: number | undefined;
  qrDigitalCardWidth?: number | undefined;
  digitalCardProfileId?: string | null;
  phoneLabel?: string;
  mobileLabel?: string;
  emailLabel?: string;
  customLabel?: string;
  customLabelVariable?: string;
  labelColor?: string;
  labelTextColor?: string;
  generatorLink?: string;
  domainRules?: string[];
  domainRulesMatchMode?: "ANY_RECIPIENT" | "ALL_RECIPIENTS" | "INSTALL_ANY";
  domainRulesIgnoreSenderDomain?: boolean;
  contentLoaded?: boolean;
}

export interface ChangeSignatureObject {
  templateId: string;
  body: string;
  parsedBody: string;
}

export interface SignaturesState {
  signatures: Signature[];
  isFirstInstallation?: boolean;
}

export interface Template {
  templateId: string;
  name: string;
  content: string;
  domain: string;
  created: number;
}

export interface SaveSignatureRequest {
  content: string;
  addonLinkId?: string | null;
  addonBannerId?: string | null;
  addonAdditionalBannerId?: string | null;
  addonDisclaimerId?: string | null;
  userAvatarWidth?: number | undefined;
  userAvatarHeight?: number | undefined;
  userAvatarBorderRadius?: number | undefined;
  qrDigitalCardWidth?: number | undefined;
  digitalCardProfileId?: string | null;
  phoneLabel?: string | null;
  mobileLabel?: string | null;
  emailLabel?: string | null;
  customLabel?: string | null;
  customLabelVariable?: string | null;
  labelColor?: string | null;
  labelTextColor?: string | null;
  domainRules?: string[];
  domainRulesMatchMode?: "ANY_RECIPIENT" | "ALL_RECIPIENTS" | "INSTALL_ANY";
  domainRulesIgnoreSenderDomain?: boolean;
}

export interface SignaturePredefined {
  templatePredefinedId: string;
  name: string;
  content: string;
  placeholderVariables: Record<string, string>;
}

export interface SaveTemplatePredefined {
  name: string;
  content: string;
  placeholderVariables: Record<string, string>;
}

export enum SetForAll {
  EMPLOYEES = "employees",
  ALIASES = "aliases",
  EMPLOYEES_AND_ALIASES = "employeesAndAliases",
}

export interface InstallationResponse {
  updated: number;
  limit?: number;
  reason?: string;
  isFirstInstallation?: boolean;
}

export type VariablePaletteContext = "default" | "print-card";

export interface VariableInfo {
  name: string;
  displayName: string;
  description: string;
  category: "company" | "user" | "phone" | "branch" | "other" | "cards";
  icon: string;
}

export type PrintCardVariableCategory = "company" | "user" | "phone" | "cards";

export interface PrintCardVariableDefinition {
  name: string;
  category: PrintCardVariableCategory;
  displayNameKey: string;
  descriptionKey: string;
  icon: string;
}
